import { CultureInfo } from '../culture-info.model';
import { CultureInfoPt } from './pt';

/**
 * @ignore
 */
export const CultureInfoPtCV: CultureInfo = {
  name: 'pt-CV',
  displayName: 'português (Cabo Verde)',
  iso3LanguageCode: 'por',
  iso2LanguageCode: 'pt',
  ietfLanguageTag: 'pt-CV',
  parent: CultureInfoPt
};
